import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { formatDateTimeOrdinal } from './date_util';

export const IssueDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [issue, setIssue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/apiissue/${id}`, { credentials: 'include' })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        setIssue(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  const formatDate = formatDateTimeOrdinal;

  if (loading) return <div className="location"><p>Loading...</p></div>;
  if (!issue) return (
    <div className="location">
      <div className="locationDetailsWrapper">
        <p>Issue not found.</p>
        <button onClick={() => navigate('/issues')} className="mainButton">← Back to Issues</button>
      </div>
    </div>
  );

  const dateSubmitted = issue[1] ? formatDate(issue[1].value) : '';
  const issueType = issue[6] ? issue[6].value : '';
  const additionalInfo = issue[7] ? issue[7].value : '';

  return (
    <div className="location">
      <div className="locationDetailsWrapper">
        <button onClick={() => navigate('/issues')} className="mainButton" style={{ marginBottom: '16px' }}>← Back to Issues</button>
        <h2>Issue Details</h2>

        <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">Date Submitted</p><p className="field">{dateSubmitted}</p>
          </div>
          <div style={{ flex: 1 }}>
            <p className="fieldLabel">Issue Type</p><p className="field">{issueType}</p>
          </div>
        </div>

        {additionalInfo && (
          <div style={{ marginBottom: '8px' }}>
            <p className="fieldLabel">Additional Information</p><p className="field">{additionalInfo}</p>
          </div>
        )}
      </div>
    </div>
  );
};
